import { Component } from '@opten/compiler/metadata/component';

declare const Swiper: any;

@Component({ className: 'js-slider' })
export class SliderComponent {
	private progressBar: HTMLElement;
	private idProgress: number= 0;
	private swiper;
	constructor(private element: HTMLElement) {
		this.progressBar = element.querySelector('.js-slider-progress-bar');
		const autoPlayDelay = 3000;
		this.swiper = new Swiper(element, {
			effect: 'fade',
			loop: true,
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 30,
			grabCursor: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			watchOverflow: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			roundLengths: true,
			autoplay: {
				delay: autoPlayDelay,
				disableOnInteraction: false
			},
			on: {
				init: () => {
					this.moveProgressbar(autoPlayDelay);
				},
				slideChange: () => {
					var defaultSlideDelay = this.swiper.params.autoplay.delay;
					var currentIndex = this.swiper.realIndex + 1;
					var currentSlide = this.swiper.slides[currentIndex];
					var currentSlideDelay = currentSlide.getAttribute('data-swiper-autoplay') || defaultSlideDelay;
					
					this.moveProgressbar(currentSlideDelay);
				}
			}
		});
	}

	moveProgressbar(currentSlideDelay) {
		var width = 0;
		var autoplayTime = currentSlideDelay / 100;
		if(this.idProgress > 0){
			clearInterval(this.idProgress);
		}
		this.idProgress = setInterval(() => {
			if (width >= 100) {
				clearInterval(this.idProgress);
			} else {
				width++; 
				this.progressBar.style.width = width + '%'; 
			}
		}, autoplayTime);

	}

}
